import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { UserUtil } from '../../data/utils/user.utils';

@Directive({
  selector: '[appIfRoles]',
})
export class IfRolesDirective implements OnInit {
  @Input()
  public appIfRoles!: string[];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private userUtil: UserUtil
  ) {}

  public ngOnInit(): void {
    const user = this.userUtil.getUser();

    if (!user.profiles) {
      this.viewContainerRef.clear();
    }

    const idx = user.profiles.findIndex(
      (element: any) => this.appIfRoles.indexOf(element) !== -1
    );

    if (idx < 0) {
      this.viewContainerRef.clear();
    } else {
      // appends the ref element to DOM
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
